const generalStrings = {
  registerForm: {
    nextBtnText: 'Next',
    backBtnText: 'Back',
    createAccountBtnText: 'Create Account',
    businessIndustryRadioButtons: {
      businessIndustryTechnologyRadioButtonText: 'Technology',
      businessIndustryMedicalRadioButtonText: 'Medical',
      businessIndustryTransportationRadioButtonText: 'Transportation',
      businessIndustryGroceriesRadioButtonText: 'Groceries',
      businessIndustryFoodRadioButtonText: 'Food',
      businessIndustryRestaurantsRadioButtonText: 'Restaurants',
      businessIndustrySportsRadioButtonText: 'Sports',
      businessIndustryFurnitureRadioButtonText: 'Furniture',
      businessIndustryTourismRadioButtonText: 'Tourism',
      businessIndustryClothingRadioButtonText: 'Clothing',
      businessIndustryBeautyRadioButtonText: 'Beauty',
      businessIndustryOtherRadioButtonText: 'Other',
    },
    userPositionRadioButtons: {
      userPositionBusinessOwnerRadioButtonText: 'Business owner',
      userPositionHrManagerRadioButtonText: 'HR manager',
      userPositionCompanyDoctorRadioButtonText: 'Company doctor',
      userPositionEmployeeRadioButtonText: 'Empoyee',
      userPositionHealthManagerRadioButtonText: 'Health manager',
      userPositionOtherRadioButtonText: 'Other',
    },
    businessIndustryTitle: 'Which is your business industry?',
    businessIndustrySubTitle: 'Lorem ipsum is placeholder text commonly used',
    formBusinessIndustryFieldLabel: 'Business Industry',
    formOtherBusinessIndustryFieldLabel: 'Your business industry',
    companyInformationTitle: 'Company Information',
    companyInformationSubTitle: 'Lorem ipsum is placeholder text commonly used',
    formCompanyNameFieldLabel: 'Company Name',
    formCompanyCityFieldLabel: 'City',
    formCompanyCityFieldPlaceholder: 'Select City',
    formCompanyAreaFieldLabel: 'Area',
    formCompanyAreaFieldPlaceholder: 'Select Area',
    formCompanyLocationFieldLabel: 'Location Address',
    formCompanyLocationFieldPlaceholder: 'Street Name, Building No',
    formCompanyApartmentFieldLabel: 'Floor, Apartment',
    formCompanyApartmentFieldPlaceholder: 'Floor, Apartment, etc',
    formCompanyEmailFieldLabel: 'Company Email',
    formCompanyWebsiteFieldLabel: 'Website URL',
    formCompanyMobileNumberFieldLabel: 'Mobile Number',
    formCompanyPhoneNumberFieldLabel: 'Phone Number ',
    formCompanyFaxFieldLabel: 'Fax',
    userPositionTitle: 'What’s your position?',
    userPositionSubTitle: 'Lorem ipsum is placeholder text commonly used',
    formUserPositionFieldLabel: 'Position',
    formOtherUserPositionFieldLabel: 'Your position',
    accountInformationTitle: 'Final step — Create your account',
    accountInformationSubTitle: 'Lorem ipsum is placeholder text commonly used',
    formAccountNameFieldLabel: 'Full Name',
    formAccountEmailFieldLabel: 'Email',
    formAccountMobileNumberFieldLabel: 'Mobile Number',
    formAccountPasswordFieldLabel: 'Password',
    formEmptyFieldErrorText(fieldName) {
      return `${fieldName} is required`;
    },
    formWrongFieldErrorText(fieldName) {
      return `${fieldName} is incorrect`;
    },
    formEmptyOtherRadioButtonErrorText: 'You must enter a value',
    formEmptyCompanyApartmentErrorText: 'Apartment is required',
    formWeakPassowrdErrorText: 'Password must have at least 6 characters',
    formConfirmationTitle: 'Your account is almost created',
    formConfirmationSubTitle: 'We will contact you shortly',
    formErrorTitle: 'Sorry, Something went wrong',
    formErrorSubTitle: 'Please try again',
  },

  notFound: {
    title: 'You went off limits here',
    subTitle: 'Choose a tab from the sidebar to continue browsing',
  },
};

export default generalStrings;
